"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionButtons = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../../../reducers/slices/main");
var vexall_reports_1 = require("../../../../../../api/calls/product/vexall/vexall_reports");
var hearder_array = [
    { display: "trans_number", key: "trans_number" },
    { display: "req_number", key: "req_number" },
    { display: "discount_amount", key: "discount_amount" },
    { display: "transaction_amount", key: "transaction_amount" },
    { display: "processed", key: "processed" },
    { display: "card_number", key: "card_number" },
    { display: "branch_name", key: "branch_name" },
    { display: "pharmacy_rams_no", key: "pharmacy_rams_no" },
    { display: "type", key: "type" },
    { display: "cell_number", key: "cell_number" },
    { display: "emp_number", key: "emp_number" },
    { display: "customer", key: "customer" },
    { display: "deal_name", key: "deal_name" },
];
var details_array = [
    { display: "trans_id", key: "trans_id" },
    { display: "product_code", key: "product_code" },
    { display: "qty", key: "qty" },
    { display: "price", key: "price" },
    { display: "total_price", key: "total_price" },
    { display: "discount", key: "discount" },
    { display: "branch_name", key: "branch_name" },
    { display: "card_number", key: "card_number" },
    { display: "time", key: "time" },
    { display: "description", key: "description" },
    { display: "deal_name", key: "deal_name" },
];
function useActionButtons(clientUserBranches, filterActions) {
    var _a, _b, _c;
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var selectedBranches = (_a = filterActions.find(function (filter) { return filter.key === "branch_id"; }).value) !== null && _a !== void 0 ? _a : [];
    var selectedDateFrom = (_b = filterActions.find(function (filter) { return filter.key === "from_date"; }).value) !== null && _b !== void 0 ? _b : null;
    var selectedDateTo = (_c = filterActions.find(function (filter) { return filter.key === "to_date"; }).value) !== null && _c !== void 0 ? _c : null;
    var reportPayload = {
        branch_name: Array.isArray(selectedBranches) ? selectedBranches : [selectedBranches],
        from_date: selectedDateFrom,
        to_date: selectedDateTo,
    };
    var actionButtons = (0, react_1.useMemo)(function () { return [
        {
            iconClassname: "solar:cloud-download-bold",
            label: "Export To CSV",
            onClick: function () {
                var _a, _b;
                if (!(reportPayload === null || reportPayload === void 0 ? void 0 : reportPayload.from_date) && !(reportPayload === null || reportPayload === void 0 ? void 0 : reportPayload.to_date)) {
                    dispatch((0, main_1.setMessageModal)({ title: "Date selection is required!", messages: ["Please select a date range in the filter to export!"] }));
                    return;
                }
                if (((_a = reportPayload === null || reportPayload === void 0 ? void 0 : reportPayload.branch_name) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                    delete reportPayload.branch_name;
                }
                if ((user === null || user === void 0 ? void 0 : user.role) === "AREA_MANAGER" && !(reportPayload === null || reportPayload === void 0 ? void 0 : reportPayload.branch_name)) {
                    dispatch((0, main_1.setMessageModal)({ title: "Branch selection is required!", messages: ["Area Managers must select one or more branches!"] }));
                    return;
                }
                if ((user === null || user === void 0 ? void 0 : user.role) === "BRANCH_MANAGER" && !(reportPayload === null || reportPayload === void 0 ? void 0 : reportPayload.branch_name)) {
                    reportPayload.branch_name = [(_b = clientUserBranches[0]) === null || _b === void 0 ? void 0 : _b.display_name];
                }
                (0, vexall_reports_1.get_loyalty_reports)(reportPayload)
                    .then(function (response) {
                    var _a, _b, _c, _d;
                    if (response === null || response === void 0 ? void 0 : response.success) {
                        var csvHeaders = __spreadArray([
                            hearder_array
                                .map(function (x) {
                                return x.display;
                            })
                                .join(",")
                        ], (_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a.loyalty_transaction_header) === null || _b === void 0 ? void 0 : _b.map(function (row) {
                            return hearder_array.map(function (x) { return JSON.stringify(row[x.key], function (key, value) { return (value === null ? "" : value); }); }).join(",");
                        }), true).join("\r\n");
                        var csvDetails = __spreadArray([
                            details_array
                                .map(function (x) {
                                return x.display;
                            })
                                .join(",")
                        ], (_d = (_c = response.content) === null || _c === void 0 ? void 0 : _c.loyalty_transaction_detail) === null || _d === void 0 ? void 0 : _d.map(function (row) {
                            return details_array.map(function (x) { return JSON.stringify(row[x.key], function (key, value) { return (value === null ? "" : value); }); }).join(",");
                        }), true).join("\r\n");
                        downloadFile(csvHeaders, "loyalty_transaction_header.csv");
                        downloadFile(csvDetails, "loyalty_transaction_details.csv");
                    }
                })
                    .catch(function (error) {
                    console.log("get loyalty reports error: ", error);
                });
            },
        },
    ]; }, [reportPayload]);
    var downloadFile = function (data, fileName) {
        var csv = data;
        var element = document.createElement("a");
        var file = new Blob([csv], { type: "text/csv" });
        element.style.display = "none";
        element.href = URL.createObjectURL(file);
        element.download = fileName;
        element.click();
        element.remove();
    };
    return (0, react_1.useMemo)(function () { return ({
        actionButtons: actionButtons,
    }); }, [actionButtons]);
}
exports.useActionButtons = useActionButtons;
